import { ReoIcon } from '@reolink-web/components.basic';
import React from 'react';
import styles from './index.module.less';
import classNames from 'classnames';
import CompLangCountryChangeModal from '@/components/LangCountryChangeModal';
import { HeaderContext } from '../../common';
import eventBus from '@/utils/event';

const CompHeaderLangCountry: React.FC = () => {
    const { langList, countryList, countryTitle, getTextByKey } = React.useContext(HeaderContext);
    const [isChangeModalOpen, setIsModalOpen] = React.useState(false);

    React.useEffect(() => {
        const handleModalOpen = (): void => {
            setIsModalOpen(true);
        };

        eventBus.on('countryLangModalOpen', handleModalOpen);
        return () => {
            eventBus.off('countryLangModalOpen', handleModalOpen);
        };
    }, []);
    return (
        <>
            <li className={ classNames(styles['header-action-item'], styles['lang-country-action']) }>
                <div
                    className={ styles['lang-country-select'] }
                    onClick={ () => {
                        // 未加载出国家时点击无效
                        if (!countryTitle) {
                            return;
                        }
                        setIsModalOpen(true);
                    } }
                    title={ getTextByKey('country-select') }
                >
                    <ReoIcon
                        className={ styles['header-action-item-icon'] }
                        name={ 'icon-region' } />
                    <span className={ styles['lang-country-select-text'] }>{countryTitle}</span>
                </div>
            </li>
            <CompLangCountryChangeModal
                isOpen={ isChangeModalOpen }
                onClose={ () => {
                    setIsModalOpen(false);
                } }
                key={ 'LangCountryChangeModal' }
                langList={ langList }
                countryList={ countryList }
            />
        </>
    );
};

export default CompHeaderLangCountry;
